module.exports = __webpack_public_path__ + "static/img/news7.b36549e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news7.jpg
// module id = B8Vp
// module chunks = 1